import { IconSymbolResponsiveSizeType, IconSymbolSizeType } from '../../../../theme/type/icon-symbol-type';
import { BreakpointSizeType } from '../../../../theme/type/breakpoints-type';
import { breakpointPrefix } from '../../../../utils/tailwind';

export const symbolWrapperSizeClass: Record<IconSymbolSizeType, string> = {
    xsmall: 'h-[3rem] w-[3rem] min-w-[3rem]',
    vsmall: 'h-[3.2rem] w-[3.2rem] min-w-[3.2rem]',
    small: 'h-[3.6rem] w-[3.6rem] min-w-[3.6rem]',
    medium: 'h-[4rem] w-[4rem] min-w-[4rem]',
    large: 'h-[4.8rem] w-[4.8rem] min-w-[4.8rem]',
    vlarge: 'h-[5.2rem] w-[5.2rem] min-w-[5.2rem]',
    xlarge: 'h-[8rem] w-[8rem] min-w-[8rem]',
};

export const symbolImageSizeClass: Record<IconSymbolSizeType, string> = {
    xsmall: 'h-[2rem] w-[2rem] min-w-[2rem]',
    vsmall: 'h-[2.2rem] w-[2.2rem] min-w-[2.2rem]',
    small: 'h-[2.6rem] w-[2.6rem] min-w-[2.6rem]',
    medium: 'h-[3rem] w-[3rem] min-w-[3rem]',
    large: 'h-[3.8rem] w-[3.8rem] min-w-[3.8rem]',
    vlarge: 'h-[4.2rem] w-[4.2rem] min-w-[4.2rem]',
    xlarge: 'h-[5.6rem] w-[5.6rem] min-w-[5.6rem]',
};

export const symbolImageSelectorClass: Record<IconSymbolSizeType, string> = {
    xsmall: '[&_i]:h-[2rem] [&_i]:w-[2rem] [&_i]:min-w-[2rem]',
    vsmall: '[&_i]:h-[2.2rem] [&_i]:w-[2.2rem] [&_i]:min-w-[2.2rem]',
    small: '[&_i]:h-[2.6rem] [&_i]:w-[2.6rem] [&_i]:min-w-[2.6rem]',
    medium: '[&_i]:h-[3rem] [&_i]:w-[3rem] [&_i]:min-w-[3rem]',
    large: '[&_i]:h-[3.8rem] [&_i]:w-[3.8rem] [&_i]:min-w-[3.8rem]',
    vlarge: '[&_i]:h-[4.2rem] [&_i]:w-[4.2rem] [&_i]:min-w-[4.2rem]',
    xlarge: '[&_i]:h-[5.6rem] [&_i]:w-[5.6rem] [&_i]:min-w-[5.6rem]',
};

const getResponsiveClasses = (size: IconSymbolResponsiveSizeType, map: Record<IconSymbolSizeType, string>) => {
    const entries = Object.entries(size) as [BreakpointSizeType, IconSymbolSizeType][];

    return entries.map(([breakpoint, value], index) => {
        const className = map[value];

        return index === 0 ? className : `${breakpointPrefix[breakpoint]}${className}`;
    });
};

export const getSymbolSizeClasses = (
    size: IconSymbolSizeType | IconSymbolResponsiveSizeType,
    map: Record<IconSymbolSizeType, string>,
) => {
    if (typeof size === 'string') {
        return map[size];
    }

    return getResponsiveClasses(size, map).join(' ');
};
